import createIntroHintNode from './createIntroHintNode';
import { getIntentDetectionHintNodeText } from './getIntentDetectionHintNodeText';
import { logSimpleSonoraDatapoint } from '../../dataLogger/logSonoraDatapoint';
import { updateIntentDetectionHint } from '../../mutators/sonoraHintMutators';
import { EntityType } from '@augloop-types/honeybee';
import { SonoraHintType, SonoraViewState } from 'owa-editor-sonora-types';
import { trace } from 'owa-trace';
import { ContentPosition, IEditor } from 'roosterjs-editor-types';

// Shows the hint to the user by appending it in a span of grey text right
// after the cursor if intent is detected from the context.
// For calendar, intent detection is not yet hooked up so viewState may be null.
export default function handleIntentDetectionHintInEditor(
    viewState: SonoraViewState,
    editor: IEditor | undefined,
    entityType: EntityType | undefined,
    triggerCharacter: string
): HTMLElement | null {
    if (editor && entityType) {
        const nodeText = getIntentDetectionHintNodeText(entityType, triggerCharacter);
        if (nodeText != '') {
            const node = createIntroHintNode(editor, nodeText, triggerCharacter);
            trace.info('[Sonora Plugin] Adding intent detection hint to editor.');
            editor.insertNode(node, {
                position: ContentPosition.SelectionStart,
                updateCursor: false,
                replaceSelection: true,
                insertOnNewLine: false,
            });

            updateIntentDetectionHint(viewState, entityType);
            logSimpleSonoraDatapoint('SonoraHintDisplayedOnIntentDetected', {
                sessionId: viewState.sessionId,
                entityType: EntityType[entityType],
                triggerCharacter: triggerCharacter,
                hintType: SonoraHintType[SonoraHintType.GhostText],
            });

            return node;
        }
    }

    return null;
}
